/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import BoardRanges from 'solis/logic/board/ranges';
import BoardTransfer from 'solis/claude/logic/board/transfer';
import SectorCass from 'solis/logic/board/sector/cass';
import SectorUsers from 'solis/logic/board/sector/users';


export default (board) =>
{
  const ranges = new BoardRanges(board);

  for (const sector of ranges.getSectors())
  {
    new SectorCass(sector).setCurrentUser(new SectorUsers(sector).getCurrentWinner());
  }

  const transfer = new BoardTransfer(board);

  for (const sector of ranges.getSectors())
  {
    new SectorCass(sector).setFutureColony(transfer.shouldTransfer(sector) ? transfer.getTargetColony(sector) : sector.cass.colony);
  }
};
